import { COMPETITOR_INFO_URL } from '../../utils/apiUrls';
import { getRequest } from '../../utils/http';

export interface CompetitorOffer {
	speed: string;
	download_speed: string;
	offer_price: number;
	offer_name: string;
	access_type: string;
	notes: string;
	talking_points: {
		instruction: string;
		dialog_script: string[];
	};
}

export interface CompetitorInfoResponse {
	competitor: string;
	competitor_intelligence: CompetitorOffer[];
}

export const fetchCompetitorInfo = async (zip: string): Promise<CompetitorInfoResponse[]> => {
	try {
		const response = await getRequest(COMPETITOR_INFO_URL + zip);

		const competitorInfo: CompetitorInfoResponse[] = response.map((competitor: any) => ({
			competitor: competitor.competitor,
			competitor_intelligence: competitor.competitor_intelligence.map((item: any) => {
				const parsedTalkingPoints = JSON.parse(item.talking_points);
				return {
					talking_points: {
						instruction: parsedTalkingPoints.instruction,
						dialog_script: parsedTalkingPoints["dialog script"],
					},
					access_type: item.access_type,
					modem: item.modem,
					price_duration: item.price_duration,
					data_cap: item.data_cap,
					offer_name: item.offer_name,
					download_speed: item.download_speed,
					speed: item.speed,
					offer_price: item.offer_price,
					notes: item.notes,
					fiber_overbuilder_price_reference: item.fiber_overbuilder_price_reference,
					update_date: item.update_date
				};
			})
		}));

		return competitorInfo;
	} catch (error) {
		console.error('Error calling Competitive Info API:', error);
		throw error;
	}
};